export enum DatadogRumAction {
  ClientsSorted = 'ClientsSorted',
  ProspectsSorted = 'ProspectsSorted',
  TasksSorted = 'TasksSorted',
  ViewGuidedFlow = 'ViewGuidedFlow',
  NoteCreated = 'NoteCreated',
  NoteUpdated = 'NoteUpdated',
  UpdatedContact = 'UpdatedContact',
  FilterActivities = 'FilterActivities',
  CallCreated = 'CallCreated',
  MeetingCreated = 'MeetingCreated',
  StartTaskCreation = 'StartTaskCreation',
  NoteDeleted = 'NoteDeleted',
  UpdateHousehold = 'UpdateHousehold',
  CoClientCreated = 'CoClientCreated',
  CallDeleted = 'CallDeleted',
  DialpadCallDeleted = 'DialpadCallDeleted',
  StartedTaskEdit = 'StartedTaskEdit',
  TaskDeleted = 'TaskDeleted',
  ProspectCreated = 'ProspectCreated',
  LoginAsClicked = 'LoginAsClicked',
  LoginAsAdvisorClicked = 'LoginAsAdvisorClicked',
  OpenedInSalesforce = 'OpenedInSalesforce',
  OpenedInOrion = 'OpenedInOrion',
  StartedGoalsEdit = 'StartedGoalsEdit',
  HouseholdSearch = 'HouseholdSearch',
  TaskSearch = 'TaskSearch',
  TasksFiltered = 'TasksFiltered',
  TaskViewed = 'TaskViewed',
  TaskCreated = 'TaskCreated',
  TaskEdited = 'TaskEdited',
  ReplyDraftGenerated = 'ReplyDraftGenerated',
  ReplyDraftCopied = 'ReplyDraftCopied',
  ClientPortalMessageCreated = 'ClientPortalMessageCreated',
  ClientPortalMessageRemoved = 'ClientPortalMessageRemoved',
  FinancialRecommendationsGenerated = 'FinancialRecommendationsGenerated',
  SavvyCatalogClicked = 'SavvyCatalogClicked',
  // Keeps its original name though the surface is now "SWIM Resources" — the
  // string is the key Datadog dashboards and monitors group on, so renaming it
  // would split the series.
  InvestmentResourcesClicked = 'InvestmentResourcesClicked',
  InvestmentResearchClicked = 'InvestmentResearchClicked',
  SavvyOfferingClicked = 'SavvyOfferingClicked',
  SavvyAlternativeFundsClicked = 'SavvyAlternativeFundsClicked',
  ReportingClicked = 'ReportingClicked',
  AlternativeFundLinkClicked = 'AlternativeFundLinkClicked',
  ProcessedOnboardedClient = 'ProcessedOnboardedClient',
  RMDTrackerClicked = 'RMDTrackerClicked',
  RMDTrackerSearch = 'RMDTrackerSearch',
  AddSecondaryPortfolio = 'AddSecondaryPortfolio',
  AUMEqualityCheck = 'AUMEqualityCheck',
  ReportAnIssueClicked = 'ReportAnIssueClicked',
  ShareFeedbackClicked = 'ShareFeedbackClicked',
  DocumentationClicked = 'DocumentationClicked',
  ReportIssueClicked = 'ReportIssueClicked',
  ReportIssueSubmitted = 'ReportIssueSubmitted',
  ViewClientsFromAdvisoryTeamChanged = 'ViewClientsFromAdvisoryTeamChanged',
  HideRevenueFromSupportRolesChanged = 'HideRevenueFromSupportRolesChanged',
  OrganizationBrandingEnabledChanged = 'OrganizationBrandingEnabledChanged',
  OrganizationTaskCompletionEmailsChanged = 'OrganizationTaskCompletionEmailsChanged',
  ClientBenchmarkComparisonEnabledChanged = 'ClientBenchmarkComparisonEnabledChanged',
  ClientBenchmarkComparisonProductKeyChanged = 'ClientBenchmarkComparisonProductKeyChanged',
  ClientAdvisoryFeesEnabledChanged = 'ClientAdvisoryFeesEnabledChanged',
  ClientAllocationSortByRatioEnabledChanged = 'ClientAllocationSortByRatioEnabledChanged',
  ClientClosedPositionsVisibleChanged = 'ClientClosedPositionsVisibleChanged',
  ClientHiddenPortalSurfacesChanged = 'ClientHiddenPortalSurfacesChanged',
  ClientSchedulingVisibilityChanged = 'ClientSchedulingVisibilityChanged',
  OfferingQuickLinkClicked = 'OfferingQuickLinkClicked',
  ExploreInvestmentProposalToolClicked = 'ExploreInvestmentProposalToolClicked',
  EnrollClientInSWIMClicked = 'EnrollClientInSWIMClicked',
  MeetingPrepCtaClicked = 'MeetingPrepCtaClicked',
  TimelineDensityChanged = 'TimelineDensityChanged',
  UpdateProfessionalContact = 'UpdateProfessionalContact',
  ClientOutdated = 'ClientOutdated',
}
